// @flow

import styled from 'styled-components';
import breakpoint from 'styled-components-breakpoint';
import { mt, mb } from 'styled-components-spacing';
import { sectionSpacingSmall } from '@components/Wrappers/styles';

export const StyledWrapper = styled.div`
  max-width: 1200px;
  width: 100%;
  margin: 0 auto;
  z-index: 1;
  position: relative;
  ${sectionSpacingSmall}
  ${mt(2)}
  ${breakpoint('desktop')`
    ${mt(-3)}
    ${mb(3)}
  `}
  ${breakpoint('mobile', 'tablet')`
    ${mb(3)}
  `}
`;

export const StyledHorizontalMask = styled.div`
  width: 101%;
  ${({ size }) => 'height: ' + size + 'px;'}
  left: 0;
  right: 0;
  z-index: 2;
  ${({ bottom }) => (bottom ? 'bottom: 0;' : 'top: 0;')};
`;
